// @flow

import React from 'react';
import type { Node } from 'react';

import {
  helpCardCls,
  helpCardIconCls,
  helpCardCornerTopLeftCls,
  helpCardCornerTopRightCls,
  helpCardCornerBottomRightCls,
  helpCardCornerBottomLeftCls,
} from 'shared_components/common/HelpCard.less';

type Props = {
  children: Node | string,
  icon?: Node,
};

/**
 * HelpCard
 *
 * @param {props} Props
 * @returns {Node}
 */
export function HelpCard({ children, icon }: Props): Node {
  return (
    <div className={helpCardCls}>
      <div>
        {icon ? <span className={helpCardIconCls}>{icon}</span> : null}
        {children}
      </div>
      <span className={helpCardCornerTopLeftCls} />
      <span className={helpCardCornerTopRightCls} />
      <span className={helpCardCornerBottomRightCls} />
      <span className={helpCardCornerBottomLeftCls} />
    </div>
  );
}
